var _g, _ellipse, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_764_33097)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 33.5,
    ry: 31.5,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 31.5,
    rx: 29.3125,
    ry: 27.5625,
    fill: "#01537A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_33097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6911 31.9176C42.4844 31.9176 43.9268 30.5418 43.9268 28.8466C43.9268 27.1515 42.4844 25.7756 40.6911 25.7756C38.8978 25.7756 37.4424 27.1515 37.4424 28.8466C37.4424 30.5418 38.8978 31.9176 40.6911 31.9176ZM30.9451 30.6892C33.1022 30.6892 34.8305 29.0432 34.8305 27.004C34.8305 24.9649 33.1022 23.3188 30.9451 23.3188C28.788 23.3188 27.0467 24.9649 27.0467 27.004C27.0467 29.0432 28.788 30.6892 30.9451 30.6892ZM40.6911 34.3744C38.3131 34.3744 33.5441 35.5046 33.5441 37.7525V40.5164H47.8382V37.7525C47.8382 35.5046 43.0691 34.3744 40.6911 34.3744ZM30.9451 33.146C27.9174 33.146 21.8489 34.5833 21.8489 37.4454V40.5164H30.9451V37.7525C30.9451 36.7084 31.374 34.8781 34.0249 33.49C32.8943 33.2689 31.8028 33.146 30.9451 33.146Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_764_33097",
    x: 0,
    y: 0,
    width: 69,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_33097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_764_33097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_33097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.1871,
    height: 29.4816,
    fill: "white",
    transform: "translate(19.25 17.1768)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8);
export default __webpack_public_path__ + "static/media/Icons8.033bb3c3d728de6b2eb20a0de4815962.svg";
export { ForwardRef as ReactComponent };